import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import groupBy from 'lodash/groupBy'
import mapValues from 'lodash/mapValues'
import keys from 'lodash/keys'
import toPairs from 'lodash/toPairs'
import isEmpty from 'lodash/isEmpty'
import flatMap from 'lodash/flatMap'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import SummaryCard from './SummaryCard'

const SHIPPING_CARD_NUMBER = 2

function ShippingSummaryCard({
  intl,
  active,
  logisticInfo,
  handleCardClick,
  hover,
  disabled,
}) {
  const title = intl.formatMessage({ id: 'summary.cart.card.shipping.title' })

  const content = isEmpty(logisticInfo) ? (
    <FormattedMessage id="summary.cart.card.shipping.empty" />
  ) : (
    <FormattedMessage
      id="summary.cart.card.shipping.content"
      values={{ quantity: extractPackageQuantity(logisticInfo) }}
    />
  )
  return (
    <div id="summary-shipping-card">
      <SummaryCard
        title={title}
        number={SHIPPING_CARD_NUMBER}
        content={content}
        active={active}
        onClick={handleCardClick}
        hover={hover}
        disabled={disabled}
      />
    </div>
  )
}

function extractPackageQuantity(logisticInfo) {
  const groupedLogisticInfo = mapValues(
    groupBy(logisticInfo, 'selectedSla'),
    (group) => groupBy(group, 'addressId')
  )
  const packageGroups = mapValues(
    groupedLogisticInfo,
    (slaGroup) => keys(slaGroup).length
  )
  const packages = flatMap(toPairs(packageGroups), ([sla, packageQuantity]) =>
    Array(packageQuantity).fill(sla)
  )
  return packages.length
}

ShippingSummaryCard.propTypes = {
  intl: intlShape,
  active: PropTypes.bool,
  packageQuantity: PropTypes.number,
  logisticInfo: PropTypes.array,
  handleCardClick: PropTypes.func.isRequired,
  hover: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default injectIntl(ShippingSummaryCard)
